import {
    SET_DASHBOARD_DATA,
  
  } from '../actions/AdminDashboardActions'
  
  const initialState = {
    
  }
  
  const adminDashboardReducer = function (state = initialState, action) {
    switch (action.type) {
      case SET_DASHBOARD_DATA:
        state = {
          ...state,
         dashboardData: action.payload?.data,
        }
      
        break
      default:
        state = { ...state }
        break
    }
    return state
  }
  export default adminDashboardReducer
  